import { AnimatePresence, motion } from 'framer-motion';
import type { CrmNoteDTO } from '../../../server/dto/crm-note-dto.ts';
import { TimelineList } from '../../shared/components/timeline-list/timeline-list.tsx';
import { NoteTimelineItem } from './note-timeline-item.tsx';

type Props = {
    notes: CrmNoteDTO[];
    isLoading: boolean;
};

export function ActivityPinnedNotes({ notes, isLoading }: Props) {
    const hasPinnedNotes = notes.length > 0;

    return (
        <AnimatePresence>
            {hasPinnedNotes && (
                <motion.div
                    key={'pinned-notes-accordion'}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                        duration: 0.2,
                        ease: ['easeIn', 'easeOut'],
                    }}
                >
                    <TimelineList isLoading={isLoading}>
                        <TimelineList.Group>
                            {notes.map((note) => (
                                <NoteTimelineItem key={`note-${note.noteId}`} note={note} />
                            ))}
                        </TimelineList.Group>
                    </TimelineList>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
